import React from 'react';
import cn from 'classnames';

import styles from './index.module.scss';
import { SUPPORTED_TEXT_TYPES } from './stubs';

/**
 * @param {object} props
 * @param {import('utils/types').TextType} [props.type='p']
 * @param {import('utils/types').TextTone} [props.tone='default']
 * @param {boolean} [props.truncate=false]
 * @param {string} [props.className='']
 * @param {React.ReactNode} [props.children=null]
 */
export default function Text({
  type = 'p',
  tone = 'default',
  truncate = false,
  className = '',
  children = null,
  ...rest
}) {
  const isValidVariant = SUPPORTED_TEXT_TYPES[type];
  const Component = isValidVariant ? type : 'p';

  if (!isValidVariant) {
    console.warn(
      `Unsupported text type: ${type}. Supported variants are: ${Object.keys(
        SUPPORTED_TEXT_TYPES,
      ).join(', ')}. Defaulting to 'p'.`,
    );
  }

  return (
    <Component
      className={cn(styles.text, className)}
      data-type={type}
      data-tone={tone}
      data-truncate={truncate}
      {...rest}
    >
      {children}
    </Component>
  );
}
